import {FormikProvider, useFormik, Form as FormikForm} from 'formik';
import {validateFields} from '../../settings/views/components/helper';
import React, {useCallback, useMemo, useRef} from 'react';
import {Field, FieldControlType, FieldType, RelationType} from '../../../queries-generated/types';
import RightPanel from '../../RightPanel/RightPanel';
import css from '../../settings/views/ViewEdit/constructor/form/DashboardFields.module.css';
import DashboardFields from '../../settings/views/ViewEdit/constructor/form/DashboardFields';
import Button from '../Button/Button';
import {CheckIcon, FilterIcon} from '../../SvgIcon';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import useToggle from '../../hooks/useToggle';

type Props = {
	filters: Record<string, any>;
	setFilters: (filters: Record<string, any>) => void;
};

const fields: Field[] = [
	{id: 'org_name', title: 'Организация', type: FieldType.String},
	{id: 'inn', title: 'ИНН', type: FieldType.String},
	{
		id: 'role_name',
		title: 'Роль',
		type: FieldType.Relation,
		relation: {
			type: RelationType.BelongsTo,
			model: 'Role',
			possibleValueMapper: {id: 'id', title: 'title', firstLine: 'title'},
		},
		controlType: FieldControlType.Combobox,
	},
	{
		id: 'region',
		title: 'Регион',
		type: FieldType.Relation,
		controlType: FieldControlType.Combobox,
		relation: {
			type: RelationType.BelongsTo,
			model: 'Region',
			possibleValueMapper: {id: 'id', title: 'title', firstLine: 'title'},
		},
	},
];

const Filters: React.FC<Props> = ({setFilters, filters}) => {
	const [open, toggleOpen] = useToggle(false);
	const hasFilters = useMemo(
		() =>
			Object.keys(filters)
				.map(key => filters[key])
				.filter(Boolean).length > 0,
		[filters],
	);

	const formikBag = useFormik<PlainObjectOf<any>>({
		initialValues: filters,
		validate: values => {
			const errors = validateFields(fields, values);

			if (Object.keys(errors).length) {
				return errors;
			}
		},
		onSubmit: values => {
			setFilters(values);
			toggleOpen();
		},
	});

	const rightPanelRef = useRef<HTMLDivElement>(null);

	const handleClose = useCallback(() => {
		if (open) {
			toggleOpen();
		}
	}, [open]);

	useOnClickOutside(rightPanelRef, handleClose, document.getElementById('root'));

	return (
		<>
			<Button type={'button'} onClick={toggleOpen} action iconOnly checked={hasFilters}>
				<FilterIcon />
			</Button>
			<RightPanel open={open} onClose={handleClose} forwardRef={rightPanelRef} className={css.rightPanel}>
				<FormikProvider value={formikBag}>
					<FormikForm>
						<ul className={css.list}>
							{fields && (
								<DashboardFields
									fields={Object.values(fields).map(field => ({
										...field,
										name: `${field.id}`,
									}))}
								/>
							)}
						</ul>
						<div className={css.stickyButtons}>
							<Button type="submit" title={'Применить фильтры'}>
								<CheckIcon />
								Применить
							</Button>

							<Button
								className={css.resetButton}
								secondary
								title={'Сбросить на значения по умолчанию'}
								onClick={() => formikBag.resetForm({values: {}})}
							>
								Сбросить
							</Button>
						</div>
					</FormikForm>
				</FormikProvider>
			</RightPanel>
		</>
	);
};

export default Filters;
